import { Dispatch, SetStateAction } from 'react';
import { Button, ThemeUIStyleObject } from 'theme-ui';

const SizeChartButton = ({
  setShowSizeChart,
  forwardSx,
  isKit,
}: {
  setShowSizeChart: Dispatch<SetStateAction<boolean>>;
  isKit?: boolean;
  forwardSx?: ThemeUIStyleObject;
}) => {
  return (
    <Button
      type="button"
      onClick={() => setShowSizeChart(true)}
      variant="bare"
      sx={{
        fontFamily: 'inherit',
        textDecoration: 'underline',
        textTransform: 'uppercase',
        fontWeight: 'medium',
        fontSize: ['1.2rem', isKit ? '1.2rem' : '1.4rem'],
        lineHeight: 1,
        color: 'UIGray2',
        minHeight: 0,
        transition: 'color 0.3s ease',
        flex: '0 0 auto',
        '&:hover': { color: 'black' },
        ...forwardSx,
      }}
    >
      Size Guide
    </Button>
  );
};

export default SizeChartButton;
